import React from "react";
import { Box, Typography, Avatar, Button, Grid, Paper } from "@mui/material";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

import rosie from '../assets/images/joinTeam/rosie.png';
import zeyna from '../assets/images/joinTeam/zeyna.png';
import vaishnavi from '../assets/images/joinTeam/vaishnavi.png';
import efosa from '../assets/images/joinTeam/efosa.png'

//import jd files

import jdKenya from '../assets/pdf/JD - Partnership - Africa - Kenya.pdf';
import jdMorocco from '../assets/pdf/JD- Partnership- Francophone Africa - Morocco.pdf'
import jdSenegal from '../assets/pdf/JD- Partnership- Francophone Africa - Senegal.pdf'


const testimonials = [
  {
    name: "Rosie Jarrett",
    title: "Design and Policy Lead",
    team: ", Climate and Health Team",
    quote: `“I love working at Dure Technologies. I am truly inspired by the work that takes place here. Collaborating with such a global and talented team on impactful projects with such a vision is a great experience.”`,
    image: rosie,
  },
  {
    name: "Zeyna Sy",
    title: "Lead and Climate and Health Mapping expert",
    team: ", Climate and Health Team",
    quote: `“Working at Dure Technologies on the Climate & Health project is an incredibly rewarding experience. The team’s innovative use of data and digital solutions is helping to strengthen health systems and improve responses to climate-sensitive diseases. Beyond the work itself, Dure feels like a family — a supportive and collaborative environment where everyone is encouraged to grow and contribute.”`,
    image: zeyna,
  },
  {
    name: "Vaishnavi Screenivas  ",
    title: "Project Co-ordinator",
    team: "",
    quote: `"My time at Dure has been an invaluable learning experience. I have developed a stronger grasp of global public health systems and saw first-hand how data and technology can drive more inclusive and equitable health outcomes.”`,
    image: vaishnavi,
  },
  {
    name: "Efosa Edegbe",
    title: "Lead in the Central African Republic",
    team: ", Digital Transformation Unit ",
    quote: `“I cherish my position at Dure Technologies. The groundbreaking activities happening here deeply motivate me. Partnering with an international and expert group on significant endeavors that reflect such ambition is a remarkable adventure.”`,
    image: efosa,
  },
  // Add more team members as needed
];

const jobOpenings = [
  {
    designation: "Strategic Partnership Manager",
    location: "Senegal",
    jdFile: jdSenegal
  },
  {
    designation: "Strategic Partnership Manager",
    location: "Morocco",
    jdFile: jdMorocco
  },
  {
    designation: "Strategic Partnership Manager",
    location: "Kenya",
    jdFile: jdKenya
  },
  // {
  //   designation: "Strategic Partnership Manager",
  //   location: "Senegal",
  //   jdFile: jdSenegal
  // },
  // {
  //   designation: "Strategic Partnership Manager",
  //   location: "Morocco",
  //   jdFile: jdMorocco
  // },
];

const JoinTeam = () => {
  return (
    <Box
      sx={{
        px: { xs: 2, md: 6 },
        py: 6,
        backgroundColor: "#f4f4f4",
      }}

      className="joinTeamMainSection"
      id="career"
    >
      <Paper
        elevation={2}
        sx={{
          borderRadius: 6,
          p: { xs: 2, md: 4 },
          backgroundColor: "#ffffffcc",
          backdropFilter: "blur(10px)",
        }}
      >
        <Grid container spacing={4}>
          {/* Left: Swiper */}
          <Grid size={{ xs: 12, md: 5 }} sx={{mt:5}}>
            <Swiper
              modules={[Pagination]}
              pagination={{ clickable: true }}
              slidesPerView={1}
            >
              {testimonials.map((t, i) => (
                <SwiperSlide key={i}>
                  <Box sx={{ textAlign: "left" , height:"300px" }} className="joinTeamSwiperSection">
                    <Grid container spacing={4} >
                      <Grid size={{ xs: 4, md: 3 }}>
                        {" "}
                        <Avatar
                          src={t.image}
                          alt={t.name}
                          sx={{
                            width: 100,
                            height: 100,
                            mb: 2,
                          }}
                        />
                      </Grid>
                      <Grid size={{ xs: 8, md: 9 }}>
                        <Typography
                          variant="subtitle1"
                          sx={{ color: "#69009f", mt:2, fontWeight: "bold" , fontSize:"18px" }}
                        >
                          {t.name}
                        </Typography>
                        <Typography
                          variant="body2"
                          sx={{ color: "#333", fontStyle: "italic" }}
                        >
                          {t.title}{" "}
                          <span style={{ fontWeight: 500 }}>{t.team}</span>
                        </Typography>
                      </Grid>
                    </Grid>

                    <Typography
                      variant="body1"
                      sx={{
                        mt: 0,
                        color: "#444",
                        fontStyle: "italic",
                        fontSize:'14px',
                        padding:"2px 15px"
                      }}
                    >
                      {t.quote}
                    </Typography>
                  </Box>
                </SwiperSlide>
              ))}
            </Swiper>
          </Grid>

          {/* Right: Join the Team */}
          <Grid size={{ xs: 12, md: 7 }}>
            <Box
              sx={{
                borderRadius: 8,
                p: 3,
                backgroundColor: '#fefdfd',
                opacity:0.8
              }}
            >
              <Typography
                variant="h6"
                sx={{
                  fontWeight: "bold",
                  color: "#69009f",
                  letterSpacing:"0.69px",
                  mb: 2,
                  marginTop:"20px",
                  marginLeft:"20px"
                }}
                className="joinTeamtext"
              >
                JOIN THE TEAM
              </Typography>

              <Box className="joinTeamSection">
                {jobOpenings.map((job, i) => (
                  <Box
                    key={i}
                    sx={{
                      border: "1px solid #ddd",
                      backgroundColor:"#fff",
                      borderRadius: 2,
                      p: "35px",
                      mb: 2,
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                    className="joinTeamBox"
                  >
                    <Box>
                      {/* <Typography
                        variant="body2"
                        sx={{ fontWeight: "bold", mb: 0.5 }}
                      >
                        DESIGNATION:
                      </Typography> */}
                      <Typography variant="body2" sx={{ mb: 1 , color:'#69009f'}}>
                        {job.designation}
                      </Typography>

                      {/* <Typography variant="body2" sx={{ fontWeight: "bold" }}>
                        PLACE OF ASSIGNMENT:
                      </Typography> */}
                      <Typography variant="body2">{job.location}</Typography>
                    </Box>
                    <Button
                      variant="contained"
                      className="buttonComponent seeMoreBtn"
                      sx={{
                        backgroundColor: "#69009f",
                        textTransform: "none",
                        borderRadius: 20,
                        fontSize: 12,
                        px: 2.5,
                      }}
                      onClick={() => {
                        const link = document.createElement('a');
                        link.href = job.jdFile;

                        
                        const fileExtension = job.jdFile.split('.').pop();

                        
                        const customFileName = `${job.designation}-${job.location}.${fileExtension}`;

                        link.download = customFileName; 
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                      }}
                    >
                      See More
                    </Button>
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default JoinTeam;
